import api from '../callApi';

function mapRepresentativeResponse(json) {
    if (!json) return null;
    return {
        representative: [...json]
    };
}

function getRepresentatives(address, showOnlySenators) {
    const url = `Localization/GetRepresentatives?state=${address.state.toLowerCase()}&districtNo=${
        address.district
    }`;

    return api.get(url).then(json => {
        let representativeResponse = null;
        try {
            representativeResponse = mapRepresentativeResponse(json);
            if (representativeResponse.representative.length < 2 && showOnlySenators) {
                return Promise.reject('SenatorsNotAvailable');
            }
        } catch (e) {
            return Promise.reject(e);
        }

        if (representativeResponse == null) return Promise.reject();

        return {
            ...representativeResponse,
            ...address
        };
    });
}

export default getRepresentatives;



// WEBPACK FOOTER //
// ./src/utils/localRepresentative/google-civic-service.js